import { IPhoto } from '../data_models/iphoto';
import { IAlbum, IOwnedAlbum, ISharedAlbum, ISharedAlbumPhotos, IOwnedAlbums, ISharedAlbums } from '../data_models/ialbum';
import { ITranslator } from './itranslator';
import { IAlbumPhotos } from '../data_models/ialbum';
import { Util } from '../../common_utils/util';
// import logger from 'logger_module';
import { 
  IUpdateBulkUAAssetParams,
  IUpdateBulkAGAssetParams,
  IUpdateBulkAssetPayLoadParams
} from "../photo/iphoto_data_manager";
import { IUpdateBulkAGAlbumParams, IUpdateBulkUAAlbumParams } from '../album/ialbum_data_manager';
import { PhotoClusterHelper } from '../photo/photo_cluster_helper';
import { AlbumClusterHelper } from '../album/album_cluster_helper';
import { IPhotoCaptionSorting } from '../data_models/iphoto';

/**
 * Responsible to translate all the User Assets Response Models to the Common model, which clients can understand. 
 * @export
 * @class UATranslator
 * @implements {ITranslator}
 */
export class UATranslator implements ITranslator {

  sortOrder?:string;

  static getInstance(): UATranslator {
    if (!UATranslator.instance) {
      UATranslator.instance = new UATranslator();
    }
    return UATranslator.instance;
  }
  private static instance: UATranslator;
/**
 * Method to tranlsate the user photos to common photo struecture and album photos structure based on sortCriteria.
 * @param response 
 */
  translateOwnedAlbumPhotos(sortCriteria, response: any) {
    const allTranslatedPhotos: IAlbumPhotos ={ entities: [], totalEntitiesCount: response.totalEntitiesCount, resultCount: response.resultCount };
    const entities = response.entities;
    let trnslatedPhoto;
    for (let i = 0; i < entities.length; i++) {
      if(sortCriteria === "caption"){
        trnslatedPhoto = this.translatePhotoCaptionSorting(entities[i]);
      }else{
        trnslatedPhoto = this.translatePhoto(entities[i]);
      }
      allTranslatedPhotos.entities.push(trnslatedPhoto);
    }    
    return allTranslatedPhotos;
  }
  /**
   *Method to translated the cluster meta data response to get only months
   *clusters and respective albums count in each cluster, which is used for 
   *creating pages and pagination in FE.   
   * @param {*} response
   * @returns {IOwnedAlbums}
   * @memberof UATranslator
   */
  prepareAlbumPagesData(clusterHelper: AlbumClusterHelper, response: any): any {
    let dateMap: { [key: string]: { collectionCount: string } } = {};
    let map = new Map();
    let indexData = response[0].entityMap; //finetune this
    let clustersData = response[1];
    //iterate map and set it as MAP(iterator) is returning size 0 in IE browser.
    Object.entries(indexData).forEach(entry => {
      map.set(entry[0], entry[1]);
    });
    map.forEach((value: { collectionCount: string; collectionList: [] }, key: string) => {
      let date = key;
      dateMap[date] = { collectionCount: value.collectionCount };
    });
    let firstPageData = this.translateAlbumClusters(clustersData);
    let pages = clusterHelper.setupPages(dateMap, false);
    return {
      pages: pages,
      firstPageData: firstPageData,
    };
  }
  /**
   * Method to prepage pages date with metadata and
   * to prepare first page response
   * @param {*} response
   * @returns {IOwnedAlbums}
   * @memberof UATranslator
   */
  translateAlbumClusters(response: any): IOwnedAlbums {
    const translatedAlbums: IOwnedAlbums = { clusters: {}};
    const entityMap = response.entityMap;
    const monthyearArray: string[] = Object.keys(entityMap);

    for (let i = 0; i < monthyearArray.length; i++) {
      const albums = entityMap[monthyearArray[i]].collectionList;
      const albumArray = [];
      for (let j = 0; j < albums.length; j++) {
        
        try{
          if(!albums[j].firstAssetId || (albums[j].firstAssetId && (!albums[j].firstAssetId.assetId || !albums[j].firstAssetId.thumbnailEncryption))){
            albums[j].firstAssetId = albums[j].assetIdList && albums[j].assetIdList[0];
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.info({ description: 'LIBRARY:translateAlbumClusters:missingFirstAssetId', albumRespone: JSON.stringify(albums[j]) });
          }
        }catch(e){
          //@ts-ignore
          photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:translateAlbumClusters:whileSettingFirstAsset', albumRespone:albums[j], errorCode: 'LIBRARY:translateAlbumClusters', err_desc: e, err_stack: e.stack });
        }

        try{//try/catch block to catch any missing data and continue with remaining albums.
          albumArray.push({ 'album': this.translateOwnedAlbum(albums[j]), 'photoCount': albums[j].assetIdList.length });        
        }catch(e){
          //@ts-ignore
          photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:translateAlbumClusters:Album missing info', albumRespone:albums[j], errorCode: 'LIBRARY:translateAlbumClusters', err_desc: e, err_stack: e.stack });
        }
      }
      translatedAlbums.clusters[monthyearArray[i]] = albumArray;
    }
    return translatedAlbums; // dunmy
  }
  // Will translate friends photos to the common photo model
  translateSharedAlbumPhotos(response: any): ISharedAlbumPhotos {
    const sharedAlbum = {
      albumInfo: response.entities[1],
      entities: new Array(),
      socialResposne: response.entities[0],
      errors: response.errors
    };
    let albumId = response.entities[1].albumId;
    for (let i = 0; i < response.entities[1].assetIdList.length; i++) {
      sharedAlbum.entities.push(
        this.translateSharedAlbumPhoto(response.entities[1].assetIdList[i], response.entities[1])
      );
    }
    return sharedAlbum;
  }
  /**
   *Method to get minimal response structure required to 
   *to albums in FE.
   * @param {*} response
   * @returns {IOwnedAlbum}
   * @memberof UATranslator
   */
  translateOwnedAlbum(response: any): IOwnedAlbum {
    const entity = response;
    const album: IOwnedAlbum = {
      albumId: entity.id.toString(),
      url: entity.firstAssetId?.thumbnailEncryption,
      accountId: entity.ownerAccountId,
      updateDate: entity.updateDate,
      createDate: entity.createDate,
      name: Util.getValue(entity.userTags, 'caption'),
      dataCenter: entity.dataCenter,
      systemTags: entity.systemTags,
      userTags: entity.userTags,
      firstAssetId: entity.firstAssetId,
      assetIdList: entity.assetIdList,
      ownerAccountId: entity.ownerAccountId,
      version: entity.version

    };
    return album;
  }
  /**
   * Method to tranlsate shared photo structure to common photo structure.
   * @param photo 
   * @param albumInfo 
   */

  translateSharedAlbumPhoto(photo: any, albumInfo: any): IPhoto {
    return {
      id: photo.assetId.toString(),
      createDate: photo.createDate,
      dateTaken: photo.dateTaken,
      updateDate: photo.updateDate,
      version: photo.version,
      dataCenter: albumInfo.dataCenter,
      ownerAccountId: photo.ownerId,
      userTags: [
        {
          "value": "",
          "key": "fileName"
        },
        {
          "value": photo.caption,
          "key": "caption"
        }
      ],
      systemTags: photo.systemTags || [],
      partnerAccountId: photo.partnerAccountId,
      currentImageInfo: { "currentWidth": photo.width, "currentHeight": photo.height },
      exifTags: photo.exifTags,
      assetType: photo.assetType,
      files: [{
        "fileType": "HIRES",
        "url": photo.thumbnailEncryption,
        "width": photo.width,
        "height": photo.height,
        "size": photo.size
      },
      {
        "fileType": "THUMBNAIL",
        "url": photo.thumbnailEncryption,
        "width": photo.width,
        "height": photo.height,
        "size": photo.size
      }
      ],
      albumIds: [albumInfo.id.toString()],
      faces: photo.faces || [],
      assetSource: photo.assetSource || null,
      subType: photo.subType
    };
  }
/**
 * Method to translate sharedAlbums response to common shareAlbum structure.
 * @param response 
 */
  translateSharedAlbums(response: any): ISharedAlbums {
    const sharedAlbums: ISharedAlbums = {
      albums: [],
      albumsInfo: { entities: [], totalEntitiesCount: response.totalEntitiesCount, resultCount: response.resultCount }
    };
    const allEntities = response.entities;
    for (let i = 0; i < allEntities.length; i++) {
      const entity = allEntities[i];
      const album: ISharedAlbum = {
        updateDate: entity.updateDate,
        caption: entity.caption,
        ownerInfo: entity.ownerInfo,
        likesCount: entity.likesCount,
        view: entity.view,
        ownerAccountId: entity.ownerAccountId,
        userTags: entity.userTags,
        id: entity.id.toString(),
        firstAssetId: entity.firstAssetId,
        createDate: entity.createDate,
        likes: entity.likes,
        comments: entity.comments,
        dataCenter: entity.dataCenter,
        friendsCount: entity.friendsCount,
        commentsCount: entity.commentsCount,
        systemTags: entity.systemTags
      };
      sharedAlbums.albums.push(album);
    }
    sharedAlbums.albumsInfo.entities = sharedAlbums.albums;
    return sharedAlbums;
  }

 
  /**
   * Method to prepage pages date with metadata and
   * to prepare first page response
   * @param {*} response
   * @param {PhotoClusterHelper} clusterHelper
   * @returns {*}
   * @memberof UATranslator
   */
  preparePagesData(clusterHelper: PhotoClusterHelper, response: any): any {
    let dateMap: { [key: string]: { assetCount: string } } = {};
    let map = new Map();
    let indexData = response[0].entityMap; //finetune this
    let clustersData = response[1];
    //iterate map and set it as MAP(iterator) is returning size 0 in IE browser.
    Object.entries(indexData).forEach(entry => {
      map.set(entry[0], entry[1]);
    });
    map.forEach((value: { assetCount: string; assetList: [] }, key: string) => {
      let date = key;
      dateMap[date] = { assetCount: value.assetCount };
    });
    let firstPageData = this.translateClusters(clusterHelper, clustersData);
    let pages = clusterHelper.setupPagesData(dateMap, null);
    return {
      pages: pages,
      firstPageData: firstPageData,
    };
  }

  /**
   * This method will convert photo response to custom IPhoto object and prepares first assets url of the individual cluster
   * @param {*} response
   * @param {PhotoClusterHelper} clusterHelper
   * @returns {*}
   * @memberof UATranslator
   */
  translateClusters(clusterHelper: PhotoClusterHelper, response: any): any {
    let clusterConfig = clusterHelper.clusterConfig;
    let clusterMap: {
      [key: string]: {
        assetCount: number;
        assetList: Array<IPhoto>;
        nextUrl: string;
      };
    } = {};
    let map = new Map();
    //iterate map and set it as MAP(iterator) is returning size 0 in IE browser.
    Object.entries(response.entityMap).forEach(entry => {
      map.set(entry[0], entry[1]);
    });
    map.forEach((value: { assetCount: number; assetList: [] }, key: string) => {
      let date = key;
      let assetCount = value.assetCount;
      let assetList = [];
      for (let photo of value.assetList) {
        assetList.push(this.translatePhoto(photo));
      }
      let nextUrl = '';
      if (assetCount >= clusterConfig.minAssetPerCluster) {
        //construct next url only when minAssetPerCluster is available
        let projection = "&projection=createDate,dateTaken,assetType,files,faces,ownerAccountId,parentCollectionReferences,userTags,subType"
        nextUrl = `limit=${clusterConfig.viewMoreCount}&skip=${clusterConfig.minAssetPerCluster}&date=${clusterConfig.sortCriteria}&timezoneOffset=${clusterConfig.timezoneOffset}${projection}`;
      }
      clusterMap[date] = {
        assetCount: assetCount,
        assetList: assetList,
        nextUrl: nextUrl,
      };
    });
    response = {
      entities: response.entities,
      entityMap: clusterMap,
      results: response.results,
      errorId: response.errorId,
      resultCount: response.resultCount,
      errors: response.errors || [],
      totalEntitiesCount: response.totalEntitiesCount,
    };
    return response;
  }

  /**
   * This method will convert photo response to custom IPhoto object, by the keeping entire response structure as it is
   * @param {*} response
   * @returns {*}
   * @memberof UATranslator
   */
  translateClusterAssets(params:any, clusterHelper: PhotoClusterHelper, response: any): any {
    let clusterConfig = clusterHelper.clusterConfig;
    let photoList: Array<IPhoto> = [];
    let entities = response.entities;
    for (let photo of entities) {
      photoList.push(this.translatePhoto(photo));
    }
    let nextUrl = "";
    let queryParams = new URLSearchParams(params.nextUrl);
    let limit: number = parseInt(queryParams.get('limit') || "0") || 0;
    let skip: number = parseInt(queryParams.get('skip') || "0") || 0;
    //first call, response should have 10 assets, to prepare nextUrl
    //for next page, response should have 100 assets, to prepare nextUrl
    if((skip === 0 && entities.length === clusterConfig.minAssetPerCluster) ||
        (skip !== 0 && entities.length === clusterConfig.viewMoreCount))
    { 
      skip = skip + limit;
      nextUrl = `skip=${skip}&limit=${clusterConfig.viewMoreCount}&date=${clusterConfig.sortCriteria}&timezoneOffset=${clusterConfig.timezoneOffset}`;
    }
    response = {
      entities: photoList,
      entityMap: response.entityMap,
      results: response.results,
      errorId: response.errorId,
      resultCount: response.resultCount,
      errors: response.errors || [],
      totalEntitiesCount: response.totalEntitiesCount,
      nextUrl : nextUrl
    };
    return response;
  }

  /**
   * Method to convert photo response by caption IPhotoByCaption object
   * @param {*} data
   * @returns {IPhotoByCaption}
   * @memberof UATranslator
   */
   translatePhotoCaptionSorting(data: any): IPhotoCaptionSorting {
      let captionSortingPhoto = {
        id: data.id.toString(),
        ownerAccountId: data.ownerAccountId,
        createDate: data.createDate,
        updateDate: data.updateDate,
        dataCenter: data.dataCenter,
        version: data.version,
        dateTaken: data.dateTaken,
        assetRef: data.assetRef,
        type: data.type,
        subType:  data.subType, //added manually
        faces: data.faces, //
        assetType: data.type,
        currentImageInfo:{
          currentWidth:data.thumbnailWidth,
          currentHeight:data.thumnailHeight
        },
        userTags: [
          {
            "value": data.caption,
            "key": "caption"
          },
          {
            "value": data.description,
            "key": "description"
          }
        ],
        parentCollectionReferences:[],
        systemTags:[
          {
          "value": data.journalCore ? data.journalCore : "",
          "key": "journalCore"
          },
          {
            "value": data.journalDeveloper,
            "key": "journalDeveloper"
          }
        ],
        files:[{
          "fileType": "THUMBNAIL",
          "url": data.assetRef,
          "width": data.thumbnailWidth,
          "height": data.thumbnailHeight,
          "size": data.hrImageSize
         },
         {
          "fileType": "HIRES",
          "url": data.assetRef,
          "width": data.hRWidth,
          "height": data.hRHeight,
          "size": data.hrImageSize
         }]
      };
      if(data.collectionIdList && data.collectionIdList.length > 0){
        for(let i =0; i<data.collectionIdList.length; i++){
          captionSortingPhoto["parentCollectionReferences"].push({
            ownerAccountId: data.ownerAccountId,
            collectionId: data.collectionIdList[i]
          })
        }
      }
      if(data.reportingMediaSource){
        captionSortingPhoto["reportingMediaSource"] = data.reportingMediaSource
      }
      return captionSortingPhoto;
   }
   /**
   * Method to conevert photo response to custom IPhoto object
   * @param {*} data
   * @returns {IPhoto}
   * @memberof UATranslator
   */
  translatePhoto(data: any): IPhoto {
    let photo =  {
      id: data.id.toString(),
      createDate: data.createDate,
      dateTaken: data.dateTaken,
      updateDate: data.updateDate,
      version: data.version,
      dataCenter: data.dataCenter,
      ownerAccountId: data.ownerAccountId,
      userTags: data.userTags,
      systemTags: data.systemTags,
      partnerAccountId: data.partnerAccountId,
      currentImageInfo: data.currentImageInfo,
      exifTags: data.exifTags,
      assetType: data.assetType,
      files: data.files,
      albumIds: Util.getAlbumIds(data.parentCollectionReferences),
      faces: data.faces,
      assetSource: data.assetSource || null,
      subType: data.subType
    };
    if(data.reportingMediaSource){
      photo["reportingMediaSource"] = data.reportingMediaSource
    }
    return photo;
  }
  /**
   *This method is to translate album response to owned album model structure.
   * @param respose 
   */
  translateAlbum(respose: any): IAlbum {
    const album: IAlbum = { entities: [] }
    if (respose && respose.entities && respose.entities.length > 0) {
      album.entities.push(this.translateOwnedAlbum(respose.entities[0]))
    }
    return album;

  }

  /**
   * Method to translate photo of updated photo with out disturbing the original response structure
   *
   * @param {*} respose
   * @returns {*}
   * @memberof UATranslator
   */
  translateUpdatedAsset(respose: any): any{
      respose.entities[0] = this.translatePhoto(respose.entities[0])
      return respose;
  }
  /**
   *This method is to translate album payload to user asset apy json structure.
   *
   * @param {IUpdateBulkAGAssetParams} payLoad
   * @returns {Array<IUpdateBulkUAAssetParams>}
   * @memberof UATranslator
   */
  translateAssetBulkAPIPayLoad(payLoad: IUpdateBulkAssetPayLoadParams): Array<IUpdateBulkUAAssetParams>{
    const assetList = payLoad.assetList;
    const assetParams: Array<IUpdateBulkUAAssetParams> = []
    for(let i=0; i<assetList.length ; i++){
      const asset = assetList[i];
      const obj: IUpdateBulkUAAssetParams = {_id: asset.id};
      if("name" in asset){
        obj.userTags = [{ key: 'caption', value: asset.name }]
      }
      if('dateTaken' in asset){
        obj.dateTaken = asset.dateTaken;
      }
      assetParams.push(obj);
    }
    return assetParams;
  }
  
  /**
   *This method is to translate albums or assets response to common response structure.
   *
   * @param {*} response
   * @returns {*}
   * @memberof UATranslator
   */
  translateAssetBulkApiUAResponse(response: any): any{
    const entityMap = response.entityMap;
    const translateResponse: any = {}
    Object.keys(entityMap).forEach(function (key) {                 
        var entity = entityMap[key];
        translateResponse[key] = [];
        for(let i=0; i < entity.length ;i++){
          translateResponse[key].push({id: entity[i].doc._id, message: entity[i].message});
        }

    })
    return translateResponse;
  }
  
  /**
   *This method is to translate album payload to user asset apy json structure.
  *
  * @param {IUpdateBulkAGAlbumParams} payLoad
  * @returns {Array<IUpdateBulkUAAlbumParams>}
  * @memberof UATranslator
  */
  translateAlbumBulkAPIPayLoad(payLoad: IUpdateBulkAGAlbumParams): Array<IUpdateBulkUAAlbumParams>{
    const albumList = payLoad.albumList;
    const albumParams: Array<IUpdateBulkUAAlbumParams> = []
    for(let i=0; i<albumList.length ; i++){
      const album = albumList[i];
      const obj: IUpdateBulkUAAlbumParams = {_id: album.albumId};
      if("name" in album || "description" in album){
        obj.userTags = [];
        if("name" in album){
          obj.userTags = [{ key: 'caption', value: album.name }]
        }
        if("description" in album){        
            obj.userTags.push({ key: 'description', value: album.description })        
        }
      }
     
      if('createDate' in album){
        obj.createDate = album.createDate;
      }
      if('firstAssetId' in album){
        obj.firstAssetId = album.firstAssetId;
      }
      albumParams.push(obj);
    }
    return albumParams;
  }
  trnaslateUAEditedPhoto(response: any): IPhoto{
    let entities = response.entities;
    
    return this.translatePhoto(entities[0]);
    
  }
  /**
   *This method is to prepare download payload to user asset api json structure.
  *
  * @param {*} data
  * @returns {*} payload
  * @memberof UATranslator
  */
  preparePayloadForDownload(data: any): any{
    const assetRefList = [];
    let payload: any;
    const allAssets = data.assetModels;
    for(let i = 0; i < allAssets.length; i++){
        const asset = allAssets[i];
        const assetRefPath = this.getThumbnailUrlFromFiles(asset.files);
        if(assetRefPath) {
            assetRefList.push(assetRefPath.toString())
        }
    }
    payload = {assetRefs: assetRefList, zipFileName: data.zipFileName };
    if('bundleNumber' in data){
      payload.bundleNumber = data.bundleNumber;
    }
    return payload;
  }
  /**
   *This method returns the thumbnail url from files
  *
  * @param {Array<any>} files
  * @returns {*} thumbnail url
  * @memberof UATranslator
  */
  getThumbnailUrlFromFiles(files: Array<any>): any{

    if(!files || (files && files.length <= 0)) {
      return;
    };

    for(let i = 0; i < files.length; i++){
        if(files[i].fileType === "THUMBNAIL"){
            return files[i].url;
        }
    }
  }

  translateCaptionAlbum(eachAlbumdata:any):any{
    var restructuredAlbum = {
      "@class": "Collection",
      "createDate": eachAlbumdata.createDate,
      "updateDate": eachAlbumdata.updateDate,
      "version": eachAlbumdata.version,
      "dataCenter": eachAlbumdata.dataCenter,
      "ownerAccountId": eachAlbumdata.ownerAccountId,
      "userTags": [
        {
          "value": eachAlbumdata.caption,
          "key": "caption"
        },
        {
          "value": eachAlbumdata.description,
          "key": "description"
        }
      ],
      "systemTags": [
        {
          "value": eachAlbumdata.sortCode,
          "key": "sortCode"
        }
      ],
      "assetIdList": [],
      "imagesCount": eachAlbumdata.imagesCount,
      "firstAssetId": {
        "assetId": null,
        "ownerId": eachAlbumdata.ownerAccountId,
        "assetType": "PICTURE",
        "thumbnailEncryption": eachAlbumdata.coverImgRef
      },
      "status": null,
      "id": eachAlbumdata.id
    }
    if(eachAlbumdata.isFavorite || eachAlbumdata.isFavorite == "true") {
      restructuredAlbum["systemTags"].push({value: 'true', key: "isFavorite"})
    }
    return restructuredAlbum;
  }

  translateIndividualAlphabetCaption(data: any):any{
    debugger;
    const entities = data.entities.map(function(entry){
        return this.translateCaptionAlbum(entry) 
    }.bind(this)); 
    data.entities = entities;  
    return data;
  }

  /**
   * Translates the caption sort response to hold albumsInformation and also calender info too
   * @param data 
   */
   translateAllCaptionMinCollectionListResponse(data: any): any {
    const result = data.entityMap;
    const isAscendingOrder = this.sortOrder === 'ascending';
    const ascendingStrArr = ['0-9','A-H','I-P','Q-Z']
    const descendingStrArr = ['Z-Q','P-I','H-A','9-0']
    let jumpToModuleData:any= [
      {[ascendingStrArr[0]]: []},
      {[ascendingStrArr[1]]: []},
      {[ascendingStrArr[2]]: []},
      {[ascendingStrArr[3]]: []}
    ]
    if(!isAscendingOrder){
      jumpToModuleData = [
        {[descendingStrArr[0]]: []},
        {[descendingStrArr[1]]: []},
        {[descendingStrArr[2]]: []},
        {[descendingStrArr[3]]: []}
      ]
    }
    
    for(var k in result){
      
      const letter = k.replace(/\'/g, "")
      let charCode = letter.charCodeAt(0);
      let collectionList = [];
      let eachLetterObj = result["\'"+letter+"\'"];
      //convert all the album objects to non-caption format
      for(let i=0;i<eachLetterObj.collectionList.length;i++){
        collectionList.push(this.uaTranslator.translateCaptionAlbum(eachLetterObj.collectionList[i]));
      }
      result["\'"+letter+"\'"].collectionList = collectionList;

      if(isAscendingOrder){
        if('-1splChar' == letter || (charCode >=48 && charCode <= 57)){
          jumpToModuleData[0][ascendingStrArr[0]].push(letter); 
        }else if(charCode >=65 && charCode <= 72){
          jumpToModuleData[1][ascendingStrArr[1]].push(letter); 
        }else if(charCode >=73 && charCode <= 80){
          jumpToModuleData[2][ascendingStrArr[2]].push(letter); 
        }else if(charCode >=81 && charCode <= 122){
          jumpToModuleData[3][ascendingStrArr[3]].push(letter);
        }
      }else{
        if('-1splChar' == letter || (charCode >=48 && charCode <= 57)){
          jumpToModuleData[3][descendingStrArr[3]].push(letter); 
        }else if(charCode >=65 && charCode <= 72){
          jumpToModuleData[2][descendingStrArr[2]].push(letter); 
        }else if(charCode >=73 && charCode <= 80){
          jumpToModuleData[1][descendingStrArr[1]].push(letter); 
        }else if(charCode >=81 && charCode <= 122){
          jumpToModuleData[0][descendingStrArr[0]].push(letter);
        }
      }
      
    }
    
    const collectionListRes = {}
    for( var index=0; index < jumpToModuleData.length; index++){
       let  eachEntity = jumpToModuleData[index];
       let key = Object.keys(eachEntity)[0];
       let eachAlphabetArr = eachEntity[key];
       for(let eai=0;eai<eachAlphabetArr.length;eai++){
        collectionListRes[key] = collectionListRes[key] || {entities:[]/** to show initial response */,count:0/** to show view more */};
        let eachLetterAlbumsObj  = result["\'"+eachAlphabetArr[eai]+"\'"];
        collectionListRes[key].entities = collectionListRes[key].entities.concat(eachLetterAlbumsObj.collectionList);
        collectionListRes[key].count += parseInt(eachLetterAlbumsObj.collectionCount);
        if(collectionListRes[key].entities && collectionListRes[key].entities.length > 10) {
          collectionListRes[key].entities.length = 10;
        }
       }
    }
    return {
      initialResponse: data,//useful for viewmore ->  to reduce api calls for <= 10
      collectionListRes: collectionListRes,
      jumpToModuleData: jumpToModuleData
    }
  }

  /* istanbul ignore next */
  translateBulkApiAlbumResponse(payload: any, data: any){

  }
  /* istanbul ignore next */
  translateAssetBulkAPIAGPayLoad(data:any): any{

  };
  /* istanbul ignore next */
  translateAssetBulkApiAGResponse(data: any, response:any): any{

  };
  /* istanbul ignore next */
  getSourceList(status: any):any{

  };
  /* istanbul ignore next */
  transformSharedAlbumResponse(status: any, response: any): any{

  };
  /* istanbul ignore next */
  translateSharedAlbum(album: any): any{

  };
  /* istanbul ignore next */
  getAlbum(album: any, response:any): any{
  };
  /* istanbul ignore next */
  pushAlbum(arg0: any, arg1: any, arg2: any, arg3: string): any{
  };
  /* istanbul ignore next */
  prepareCombinations(arg0: string[]): any{
  };
  /* istanbul ignore next */
  translateFavoriteAlbumPhotos(response: any): any {    
  };
  /* istanbul ignore next */
  findIndex(data: Array<any>, key: string, keyAtr: string): any{
  }
  /* istanbul ignore next */
  updateNewValue(photo: any, key: string, value: any, index: number): any{
  }
  /* istanbul ignore next */
  trnaslateAGEditedPhoto(arg: any, response: any): any{
  }
  /* istanbul ignore next */
  prepareCollectionListInfo(response:any):any{
  }
}